import { Heading, Text } from '@cinch-labs/design-system'
import type {
  StoryblokImage,
  Text as StoryblokText,
} from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import Image from 'next/legacy/image'

import styles from './aftercare.module.css'
import { Tick } from './assets'

export interface AftercareProps {
  title: string
  body: string
  image: StoryblokImage
  products: StoryblokText[]
  hideOnSmallScreen?: boolean
  hideOnLargeScreen?: boolean
}

const Aftercare: React.FC<AftercareProps> = ({
  title,
  body,
  image,
  products,
  hideOnSmallScreen = false,
  hideOnLargeScreen = false,
}) => (
  <div
    className={cx(styles.wrapper, {
      [styles.hideOnSmallScreen]: hideOnSmallScreen,
      [styles.hideOnLargeScreen]: hideOnLargeScreen,
    })}
    data-testid="aftercare-container"
  >
    <Heading element="h2" className={styles.title}>
      {title}
    </Heading>

    <Text className={styles.body}>{body}</Text>

    <div className={styles.imageProductWrapper}>
      <div className={styles.imageWrapper}>
        <Image
          src={image.filename}
          alt={image.alt ?? undefined}
          layout="fill"
          objectFit="cover"
        />
      </div>

      <div className={styles.productItemWrapper}>
        {products.map((productItem) => (
          <div key={productItem.text} className={styles.productItem}>
            <Tick className={styles.productItemTick} />
            <Text className={styles.productItemText}>{productItem.text}</Text>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default Aftercare
